var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskDeletebtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1368",
    "data-name": "Group 1368",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.394,
    height: 33.112,
    viewBox: "0 0 26.394 33.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M233.916,143.953l-.889,24a.808.808,0,0,1-.791.761H216.879a.81.81,0,0,1-.791-.761l-.889-24a1.2,1.2,0,1,0-2.4.089l.889,24a3.209,3.209,0,0,0,3.189,3.071h15.356a3.208,3.208,0,0,0,3.189-3.071l.889-24a1.2,1.2,0,1,0-2.4-.089Z",
    transform: "translate(-211.361 -137.999)",
    fill: "#444141"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M197.2,136.8h23.994a1.2,1.2,0,0,0,0-2.4H197.2a1.2,1.2,0,0,0,0,2.4Z",
    transform: "translate(-196 -130.321)",
    fill: "#444141"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M282.845,91.693l.5-1.749a1.163,1.163,0,0,1,.982-.74h4.327a1.163,1.163,0,0,1,.982.74l.5,1.749,2.307-.659-.5-1.748a3.546,3.546,0,0,0-3.29-2.481h-4.327a3.546,3.546,0,0,0-3.289,2.481l-.5,1.748Z",
    transform: "translate(-273.294 -86.804)",
    fill: "#444141"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskDeletebtn);
export default __webpack_public_path__ + "static/media/TaskDeletebtn.a0e295dc6a7aae4c6f6d043708d6378e.svg";
export { ForwardRef as ReactComponent };